import { React, useState } from "react";
import { MovieTag } from "./MovieTag.js";
import "./movie_tag.css";

//Testing Carousel Below
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

export const MovieTagCarousel = (props) => {
  const { movieItems, isGrid, isDefaultSmall, movieType, isHoverEnable } =
    props;

  //MidAutumn
  const [focusItem, setFocusItem] = useState(null);

  function handleMouseEnter(movieId) {
    setFocusItem(movieId);
  }

  function handleMouseLeave() {
    setFocusItem(null);
  }

  //Custom Carousel Provider
  let visibleSlides, slideSize;

  if (isGrid) {
    visibleSlides = 4;
    slideSize = {
      width: "calc(0.67*30vw)",
      height: "calc(30vw)",
    };
  } else {
    visibleSlides = 3;
    slideSize = {
      width: "20vw",
      height: "calc(0.75*20vw)",
    };
  }

  if (props.isImage) {
    visibleSlides = 1;
    slideSize = {
      width: "calc((100vw - 100vw*4/30))",
      height: "calc(0.5625*(100vw - 100vw*4/30))",
    };
  }

  return (
    <CarouselProvider
      className="mov_tag carousel_container"
      naturalSlideWidth={slideSize.width}
      naturalSlideHeight={slideSize.height}
      totalSlides={movieItems.length}
      isIntrinsicHeight={true}
      touchEnabled={true}
      visibleSlides={visibleSlides}
    >
      <Slider className="mov_tag carousel_slider">
        {movieItems.map((item, index) => (
          <Slide index={index}>
            <MovieTag
              isImage={props.isImage ? props.isImage : false}
              key={index}
              isHoverEnable={isHoverEnable}
              isGrid={isGrid}
              isDefaultSmall={isDefaultSmall}
              listControl={{
                detailData: item,
                handleMouseEnter: handleMouseEnter,
                handleMouseLeave: handleMouseLeave,
                focusItem: focusItem,
                setFocusItem: setFocusItem,
                movieId: item.id ? item.id : item, //MidAutumn
                movieType: movieType,
              }}
            />
          </Slide>
        ))}
      </Slider>
      <div
        className={`mov_tag carousel_control ${
          isGrid ? "grid_tag_carousel" : ""
        }`}
      >
        <ButtonBack className="carousel_btn">
          <i className="fa-solid fa-angle-left"></i>
        </ButtonBack>
        <ButtonNext className="carousel_btn">
          <i className="fa-solid fa-angle-right"></i>
        </ButtonNext>
      </div>
    </CarouselProvider>
  );
};
